<template lang="pug">
  div
    .row.padded.padded-y.text-center.d-flex.flex-column.header-group
      .top-center-bar Choose the Right Plan for You
      .content Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod <br> tempor incididunt ut labore et dolore.
      .d-flex.flex-row.toggle-group
        .toggle-item(@click="togglePlan('month')" :class="plan == 'month' ? 'active': ''") Monthly
        .toggle-item(@click="togglePlan('annual')" :class="plan == 'annual' ? 'active': ''") Annually
        span.toggle-slider
    .row.padded.d-flex.flex-row
      .d-flex.flex-column.packages-item
        .tag.invisible BEST BUY
        .d-flex.flex-column.packages-item-card
          img(src="assets/images/icon-free.png" alt="")
          .tier FREE
          .price RM 0
          .description Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          button.btn.btn-blue BUY
      .d-flex.flex-column.packages-item
        .tag BEST BUY
        .d-flex.flex-column.packages-item-card
          img(src="assets/images/icon-basic.png" alt="")
          .tier BASIC
          .price RM 20
          .description Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          button.btn.btn-blue BUY
      .d-flex.flex-column.packages-item
        .tag.invisible BEST BUY
        .d-flex.flex-column.packages-item-card
          img(src="assets/images/icon-comprehansive.png" alt="")
          .tier COMPREHENSIVE
          .price RM 100
          .description Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
          button.btn.btn-blue BUY
    .row.padded.padded-y.text-center.d-flex.flex-column.faq-group
      .top-center-bar.padded Have more questions? Get in <a href="https://xendity.com/#contact">touch</a> or <br> head over to our <a href="">FAQs</a>
      .accordion.padded(id="accordionExample")
        .card(data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne")
          .title#headingOne
            h2.mb-0 What payment methods do you accept?
          div#collapseOne(class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample")
            .card-body Xendity accepts credit card and Paypal payments online. To pay by check, wire transfer <br> or ACH, please <a href="https://xendity.com/#contact">contact us.</a>
        .card(data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo")
          .title#headingTwo
            h2.mb-0 Do you offer nonprofit or educational pricing?
          div#collapseTwo(class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample")
            .card-body Xendity accepts credit card and Paypal payments online. To pay by check, wire transfer <br> or ACH, please <a href="/contact">contact us.</a>
        .card(data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree")
          .title#headingThree
            h2.mb-0 What happerns at the end of my trial?
          div#collapseThree(class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample")
            .card-body Xendity accepts credit card and Paypal payments online. To pay by check, wire transfer <br> or ACH, please <a href="/contact">contact us.</a>
        .card(data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour")
          .title#headingFour
            h2.mb-0 How do I cancel my service?
          div#collapseFour(class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample")
            .card-body Xendity accepts credit card and Paypal payments online. To pay by check, wire transfer <br> or ACH, please <a href="/contact">contact us.</a>
</template>

<script>
export default {
  data() {
    return {
      plan: "",
    };
  },
  methods: {
    togglePlan(val) {
      this.plan = val;
      if (this.plan == "month")
        $(".toggle-slider").animate(
          {
            left: ".2rem",
          },
          250
        );
      if (this.plan == "annual")
        $(".toggle-slider").animate(
          {
            left: "9.7rem",
          },
          250
        );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/pricing.scss";
</style>